import { render, staticRenderFns } from "./WorkEditorMain.vue?vue&type=template&id=4bbccd41&scoped=true"
import script from "./WorkEditorMain.vue?vue&type=script&lang=js"
export * from "./WorkEditorMain.vue?vue&type=script&lang=js"
import style0 from "./WorkEditorMain.vue?vue&type=style&index=0&id=4bbccd41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbccd41",
  null
  
)

export default component.exports